import { render, staticRenderFns } from "./UpdateEStock.vue?vue&type=template&id=2f315710"
import script from "./UpdateEStock.vue?vue&type=script&lang=js"
export * from "./UpdateEStock.vue?vue&type=script&lang=js"
import style0 from "./UpdateEStock.vue?vue&type=style&index=0&id=2f315710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports